export default __webpack_public_path__ + "static/media/GraphicsLead.70eedd06.png";